// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Kh4d2","col":"styles_col__3W0H5"};